import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AgFormWrapper = styled(Box)(({ theme }) => ({
  width: '400px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
}));

export const AgPageContainer = styled('div')({
  padding: '1em',
});